var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"drag_target",on:{"touchstart":_vm.dragStart,"touchend":_vm.dragEnd,"touchmove":_vm.drag,"mousedown":_vm.dragStart,"mouseup":_vm.dragEnd,"mousemove":_vm.drag}},[_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }